// 64 Bangladesh district headquarters with coordinates + Bengali names.

export interface BDCity {
  key: string;
  en: string;
  bn: string;
  division: string;
  lat: number;
  lon: number;
}

export const BD_CITIES: BDCity[] = [
  // Dhaka division
  { key: "dhaka",       en: "Dhaka",       bn: "ঢাকা",        division: "Dhaka",      lat: 23.8103, lon: 90.4125 },
  { key: "gazipur",     en: "Gazipur",     bn: "গাজীপুর",     division: "Dhaka",      lat: 23.9999, lon: 90.4203 },
  { key: "narayanganj", en: "Narayanganj", bn: "নারায়ণগঞ্জ", division: "Dhaka",      lat: 23.6238, lon: 90.5000 },
  { key: "narsingdi",   en: "Narsingdi",   bn: "নরসিংদী",     division: "Dhaka",      lat: 23.9322, lon: 90.7150 },
  { key: "manikganj",   en: "Manikganj",   bn: "মানিকগঞ্জ",   division: "Dhaka",      lat: 23.8617, lon: 90.0003 },
  { key: "munshiganj",  en: "Munshiganj",  bn: "মুন্সিগঞ্জ",  division: "Dhaka",      lat: 23.5421, lon: 90.5305 },
  { key: "tangail",     en: "Tangail",     bn: "টাঙ্গাইল",    division: "Dhaka",      lat: 24.2513, lon: 89.9167 },
  { key: "kishoreganj", en: "Kishoreganj", bn: "কিশোরগঞ্জ",   division: "Dhaka",      lat: 24.4449, lon: 90.7766 },
  { key: "faridpur",    en: "Faridpur",    bn: "ফরিদপুর",     division: "Dhaka",      lat: 23.6070, lon: 89.8429 },
  { key: "gopalganj",   en: "Gopalganj",   bn: "গোপালগঞ্জ",   division: "Dhaka",      lat: 23.0050, lon: 89.8266 },
  { key: "madaripur",   en: "Madaripur",   bn: "মাদারীপুর",   division: "Dhaka",      lat: 23.1641, lon: 90.1897 },
  { key: "rajbari",     en: "Rajbari",     bn: "রাজবাড়ী",    division: "Dhaka",      lat: 23.7574, lon: 89.6444 },
  { key: "shariatpur",  en: "Shariatpur",  bn: "শরীয়তপুর",  division: "Dhaka",      lat: 23.2423, lon: 90.4348 },

  // Chittagong division
  { key: "chittagong",     en: "Chittagong",      bn: "চট্টগ্রাম",      division: "Chittagong", lat: 22.3569, lon: 91.7832 },
  { key: "coxsbazar",      en: "Cox's Bazar",     bn: "কক্সবাজার",      division: "Chittagong", lat: 21.4272, lon: 92.0058 },
  { key: "comilla",        en: "Comilla",         bn: "কুমিল্লা",       division: "Chittagong", lat: 23.4607, lon: 91.1809 },
  { key: "feni",           en: "Feni",            bn: "ফেনী",            division: "Chittagong", lat: 23.0159, lon: 91.3976 },
  { key: "noakhali",       en: "Noakhali",        bn: "নোয়াখালী",      division: "Chittagong", lat: 22.8696, lon: 91.0995 },
  { key: "lakshmipur",     en: "Lakshmipur",      bn: "লক্ষ্মীপুর",     division: "Chittagong", lat: 22.9447, lon: 90.8282 },
  { key: "chandpur",       en: "Chandpur",        bn: "চাঁদপুর",        division: "Chittagong", lat: 23.2333, lon: 90.6712 },
  { key: "brahmanbaria",   en: "Brahmanbaria",    bn: "ব্রাহ্মণবাড়িয়া", division: "Chittagong", lat: 23.9571, lon: 91.1115 },
  { key: "bandarban",      en: "Bandarban",       bn: "বান্দরবান",      division: "Chittagong", lat: 22.1953, lon: 92.2184 },
  { key: "rangamati",      en: "Rangamati",       bn: "রাঙ্গামাটি",     division: "Chittagong", lat: 22.6533, lon: 92.1750 },
  { key: "khagrachari",    en: "Khagrachari",     bn: "খাগড়াছড়ি",     division: "Chittagong", lat: 23.1193, lon: 91.9847 },

  // Sylhet division
  { key: "sylhet",       en: "Sylhet",       bn: "সিলেট",       division: "Sylhet",     lat: 24.8949, lon: 91.8687 },
  { key: "moulvibazar",  en: "Moulvibazar",  bn: "মৌলভীবাজার",  division: "Sylhet",     lat: 24.4829, lon: 91.7774 },
  { key: "habiganj",     en: "Habiganj",     bn: "হবিগঞ্জ",     division: "Sylhet",     lat: 24.3744, lon: 91.4155 },
  { key: "sunamganj",    en: "Sunamganj",    bn: "সুনামগঞ্জ",   division: "Sylhet",     lat: 25.0658, lon: 91.3950 },

  // Rajshahi division
  { key: "rajshahi",     en: "Rajshahi",     bn: "রাজশাহী",     division: "Rajshahi",   lat: 24.3636, lon: 88.6241 },
  { key: "bogura",       en: "Bogura",       bn: "বগুড়া",      division: "Rajshahi",   lat: 24.8465, lon: 89.3776 },
  { key: "pabna",        en: "Pabna",        bn: "পাবনা",       division: "Rajshahi",   lat: 24.0064, lon: 89.2372 },
  { key: "sirajganj",    en: "Sirajganj",    bn: "সিরাজগঞ্জ",   division: "Rajshahi",   lat: 24.4534, lon: 89.7006 },
  { key: "natore",       en: "Natore",       bn: "নাটোর",       division: "Rajshahi",   lat: 24.4206, lon: 89.0003 },
  { key: "naogaon",      en: "Naogaon",      bn: "নওগাঁ",       division: "Rajshahi",   lat: 24.7937, lon: 88.9318 },
  { key: "joypurhat",    en: "Joypurhat",    bn: "জয়পুরহাট",   division: "Rajshahi",   lat: 25.0968, lon: 89.0227 },
  { key: "chapainawabganj", en: "Chapainawabganj", bn: "চাঁপাইনবাবগঞ্জ", division: "Rajshahi", lat: 24.5965, lon: 88.2775 },

  // Khulna division
  { key: "khulna",       en: "Khulna",       bn: "খুলনা",       division: "Khulna",     lat: 22.8456, lon: 89.5403 },
  { key: "jessore",      en: "Jessore",      bn: "যশোর",        division: "Khulna",     lat: 23.1664, lon: 89.2081 },
  { key: "satkhira",     en: "Satkhira",     bn: "সাতক্ষীরা",   division: "Khulna",     lat: 22.7185, lon: 89.0705 },
  { key: "bagerhat",     en: "Bagerhat",     bn: "বাগেরহাট",    division: "Khulna",     lat: 22.6517, lon: 89.7857 },
  { key: "narail",       en: "Narail",       bn: "নড়াইল",      division: "Khulna",     lat: 23.1725, lon: 89.4965 },
  { key: "magura",       en: "Magura",       bn: "মাগুরা",      division: "Khulna",     lat: 23.4854, lon: 89.4198 },
  { key: "jhenaidah",    en: "Jhenaidah",    bn: "ঝিনাইদহ",     division: "Khulna",     lat: 23.5448, lon: 89.1539 },
  { key: "kushtia",      en: "Kushtia",      bn: "কুষ্টিয়া",   division: "Khulna",     lat: 23.9013, lon: 89.1206 },
  { key: "chuadanga",    en: "Chuadanga",    bn: "চুয়াডাঙ্গা", division: "Khulna",     lat: 23.6401, lon: 88.8418 },
  { key: "meherpur",     en: "Meherpur",     bn: "মেহেরপুর",    division: "Khulna",     lat: 23.7622, lon: 88.6318 },

  // Barisal division
  { key: "barisal",      en: "Barisal",      bn: "বরিশাল",      division: "Barisal",    lat: 22.7010, lon: 90.3535 },
  { key: "bhola",        en: "Bhola",        bn: "ভোলা",        division: "Barisal",    lat: 22.6859, lon: 90.6482 },
  { key: "patuakhali",   en: "Patuakhali",   bn: "পটুয়াখালী",  division: "Barisal",    lat: 22.3596, lon: 90.3298 },
  { key: "barguna",      en: "Barguna",      bn: "বরগুনা",      division: "Barisal",    lat: 22.0953, lon: 90.1121 },
  { key: "pirojpur",     en: "Pirojpur",     bn: "পিরোজপুর",    division: "Barisal",    lat: 22.5790, lon: 89.9759 },
  { key: "jhalokati",    en: "Jhalokati",    bn: "ঝালকাঠি",    division: "Barisal",    lat: 22.6406, lon: 90.1987 },

  // Rangpur division
  { key: "rangpur",      en: "Rangpur",      bn: "রংপুর",       division: "Rangpur",    lat: 25.7439, lon: 89.2752 },
  { key: "dinajpur",     en: "Dinajpur",     bn: "দিনাজপুর",    division: "Rangpur",    lat: 25.6217, lon: 88.6354 },
  { key: "thakurgaon",   en: "Thakurgaon",   bn: "ঠাকুরগাঁও",   division: "Rangpur",    lat: 26.0419, lon: 88.4279 },
  { key: "panchagarh",   en: "Panchagarh",   bn: "পঞ্চগড়",     division: "Rangpur",    lat: 26.3411, lon: 88.5542 },
  { key: "nilphamari",   en: "Nilphamari",   bn: "নীলফামারী",   division: "Rangpur",    lat: 25.9304, lon: 88.8560 },
  { key: "lalmonirhat",  en: "Lalmonirhat",  bn: "লালমনিরহাট",  division: "Rangpur",    lat: 25.9923, lon: 89.2847 },
  { key: "kurigram",     en: "Kurigram",     bn: "কুড়িগ্রাম",  division: "Rangpur",    lat: 25.8055, lon: 89.6362 },
  { key: "gaibandha",    en: "Gaibandha",    bn: "গাইবান্ধা",   division: "Rangpur",    lat: 25.3287, lon: 89.5281 },

  // Mymensingh division
  { key: "mymensingh",   en: "Mymensingh",   bn: "ময়মনসিংহ",  division: "Mymensingh", lat: 24.7471, lon: 90.4203 },
  { key: "jamalpur",     en: "Jamalpur",     bn: "জামালপুর",    division: "Mymensingh", lat: 24.9375, lon: 89.9375 },
  { key: "sherpur",      en: "Sherpur",      bn: "শেরপুর",      division: "Mymensingh", lat: 25.0204, lon: 90.0152 },
  { key: "netrokona",    en: "Netrokona",    bn: "নেত্রকোনা",   division: "Mymensingh", lat: 24.8806, lon: 90.7274 },
];

export const BD_CITY_MAP: Record<string, BDCity> =
  Object.fromEntries(BD_CITIES.map((c) => [c.key, c]));

/**
 * Well-known road / air / train distances and travel times for popular routes.
 * Distances in km, times in minutes. Symmetric — only one direction stored.
 */
export interface RoutePreset {
  road?: { km: number; minutes: number };
  air?: { km: number; minutes: number };
  train?: { km: number; minutes: number };
}

export const ROUTE_PRESETS: Record<string, RoutePreset> = {
  // Dhaka outgoing
  "dhaka|chittagong":  { road: { km: 264, minutes: 330 }, air: { km: 244, minutes: 50 }, train: { km: 320, minutes: 390 } },
  "dhaka|sylhet":      { road: { km: 247, minutes: 330 }, air: { km: 199, minutes: 45 }, train: { km: 319, minutes: 420 } },
  "dhaka|coxsbazar":   { road: { km: 414, minutes: 570 }, air: { km: 333, minutes: 65 } },
  "dhaka|rajshahi":    { road: { km: 256, minutes: 330 }, air: { km: 192, minutes: 50 }, train: { km: 343, minutes: 360 } },
  "dhaka|khulna":      { road: { km: 270, minutes: 360 }, air: { km: 154, minutes: 50 }, train: { km: 449, minutes: 540 } },
  "dhaka|rangpur":     { road: { km: 304, minutes: 390 }, train: { km: 405, minutes: 540 } },
  "dhaka|barisal":     { road: { km: 220, minutes: 360 }, air: { km: 142, minutes: 30 } },
  "dhaka|mymensingh":  { road: { km: 121, minutes: 180 }, train: { km: 122, minutes: 180 } },
  "dhaka|comilla":     { road: { km: 100, minutes: 150 }, train: { km: 130, minutes: 180 } },
  "dhaka|jessore":     { road: { km: 248, minutes: 330 }, air: { km: 161, minutes: 50 }, train: { km: 405, minutes: 480 } },
  "dhaka|bogura":      { road: { km: 228, minutes: 300 } },
  "dhaka|gazipur":     { road: { km: 32,  minutes: 60 } },
  "dhaka|narayanganj": { road: { km: 17,  minutes: 45 } },
  "dhaka|tangail":     { road: { km: 96,  minutes: 150 } },
  "dhaka|faridpur":    { road: { km: 145, minutes: 180 } },
  "dhaka|kushtia":     { road: { km: 230, minutes: 300 } },
  "dhaka|jamalpur":    { road: { km: 187, minutes: 240 }, train: { km: 188, minutes: 270 } },
  "dhaka|noakhali":    { road: { km: 165, minutes: 240 }, train: { km: 220, minutes: 300 } },
  "dhaka|feni":        { road: { km: 151, minutes: 210 } },
  "dhaka|brahmanbaria":{ road: { km: 110, minutes: 165 } },
  "dhaka|chandpur":    { road: { km: 169, minutes: 240 } },
  // Other useful pairs
  "chittagong|coxsbazar": { road: { km: 152, minutes: 240 } },
  "chittagong|sylhet":    { road: { km: 308, minutes: 420 } },
  "chittagong|comilla":   { road: { km: 155, minutes: 210 } },
  "khulna|jessore":       { road: { km: 67,  minutes: 90 } },
  "rajshahi|bogura":      { road: { km: 100, minutes: 150 } },
  "sylhet|moulvibazar":   { road: { km: 75,  minutes: 90 } },
};

export function presetKey(a: string, b: string): string {
  return [a, b].sort().join("|");
}

export function getPreset(a: string, b: string): RoutePreset | undefined {
  if (a === b) return undefined;
  return ROUTE_PRESETS[presetKey(a, b)];
}
